import Vue from 'vue';
import Swal from "sweetalert2";
import 'sweetalert2/dist/sweetalert2.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import qs from 'querystring';
import moment from 'moment';
var numeral = require('numeral');
let sessionExpirationHandled = false;

const escapeHtml = value => String(value).replace(/[&<>'"]/g, character => ({
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	"'": '&#039;',
	'"': '&quot;'
}[character]));

Vue.use(Loading);

moment.locale(window.localStorage.lenguaje);
export default Vue.mixin({
	data() {
		return {
			load: null
		}
	},
	methods: {
		clearSession() {
			window.localStorage.removeItem("user");
			window.localStorage.removeItem("token");
			this.$store.state.user = '';
		},
		redirectToLogin() {
			const loginPath = `/${this.$t("rutas.inicio_sesion")}`;
			if (this.$route && this.$route.path === loginPath) return;

			window.location = loginPath;
		},
		handleExpiredSession(message) {
			if (sessionExpirationHandled) return;
			sessionExpirationHandled = true;

			this.clearSession();

			Swal.fire({
				icon: 'warning',
				title: '',
				html: message || 'La sesión expiró. Inicie sesión nuevamente.'
			}).then(() => {
				this.redirectToLogin();
			});
		},
		showSuccessMessage(message) {
			Swal.fire({
				icon: 'success',
				title: '',
				html: message,
				timer: 3000
			});
		},
		showErrorMessage(message) {
			Swal.fire({
				icon: 'error',
				title: '',
				html: message,
				timer: 3000
			});
		},
		showWarningMessage(message) {
			Swal.fire({
				icon: 'warning',
				title: '',
				html: message,
				timer: 3000
			});
		},
		async sendRequest(url, data = {}, method = "GET", files = false) {
			const response = {
				message: "",
				data: [],
				success: false
			};

			var requestConfig = {
				method: method,
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			};

			if (window.localStorage.token) {
				requestConfig.headers['Authorization'] = `Bearer ${window.localStorage.token}`;
			}

			if (Object.keys(data).length || data instanceof FormData) {
				if (files) {
					data.append('lenguaje', (window.localStorage.lenguaje || 'es'));
					requestConfig.body = data;
				} else {
					data = { ...data, lenguaje: window.localStorage.lenguaje || 'es' };
					requestConfig.headers['Content-Type'] = 'application/json';
					if (method == 'GET') {
						url += '?' + qs.stringify(data);
					} else {
						requestConfig.body = JSON.stringify(data);
					}
				}
			}

			try {
				const request = await fetch(url, requestConfig);
				let jsonResponse = {};
				if (request.status != 204) {
					const responseText = await request.text();
					if (responseText) {
						try {
							jsonResponse = JSON.parse(responseText);
						} catch (error) {
							jsonResponse = { message: escapeHtml(responseText) };
						}
					}
				}

				if (!request.ok) {
					response.success = false;
					if ([401, 419].includes(request.status)) {
						response.type = 'warning';
						response.message = jsonResponse.mensaje || jsonResponse.message || 'La sesión expiró. Inicie sesión nuevamente.';

						if (!url.includes('/login')) {
							this.handleExpiredSession(response.message);
							return response;
						}
					}

					if (request.status >= 500) {
						response.type = 'error';
						response.message = jsonResponse.mensaje || jsonResponse.message ||
							'El servidor no pudo completar la solicitud. Intente nuevamente.';
					}

					if ([401, 400].includes(request.status)) {
						response.type = 'warning';
						response.message = jsonResponse.mensaje || jsonResponse.message || 'No fue posible completar la solicitud.';
					}

					if (request.status == 404) {
						response.type = 'warning';
						response.message = 'Ruta inválida';
					}

					if (request.status == 403) {
						response.type = 'warning';
						response.message = jsonResponse.mensaje || jsonResponse.message ||
							'No tiene permisos para realizar esta acción.';
					}

					if (request.status == 413) {
						response.type = 'warning';
						response.message = 'Los documentos exceden el tamaño máximo permitido.';
					}

					if (request.status == 429) {
						response.type = 'warning';
						response.message = 'Se realizaron demasiadas solicitudes. Espere un momento e intente nuevamente.';
					}

					if (request.status == 422) {
						response.type = 'warning';
						var messageUl = document.createElement("ul");
						const validationErrors = jsonResponse.errors || {};
						Object.keys(validationErrors).forEach(fields => {
							var messageLi = document.createElement("li");
							const fieldErrors = Array.isArray(validationErrors[fields])
								? validationErrors[fields]
								: [validationErrors[fields]];
							var messageText = document.createTextNode(fieldErrors[0]);
							messageLi.appendChild(messageText);
							messageUl.appendChild(messageLi);
						});
						response.message = Object.keys(validationErrors).length
							? messageUl.outerHTML
							: jsonResponse.mensaje || jsonResponse.message || 'Revise la información enviada.';
					}

					if (!response.message) {
						response.type = 'error';
						response.message = jsonResponse.mensaje || jsonResponse.message ||
							`No fue posible completar la solicitud (HTTP ${request.status}).`;
					}

					throw response;
				} else {

					if (jsonResponse.datos) response.data = jsonResponse.datos;
					if (jsonResponse.data) response.data = jsonResponse.data;
					if (jsonResponse.mensaje) response.message = jsonResponse.mensaje;
					response.success = true;

					return response;
				}
			} catch (error) {
				const isHandledResponse = error === response;
				const type = isHandledResponse ? response.type : 'error';
				const message = isHandledResponse
					? response.message
					: error && error.name === 'AbortError'
						? 'La solicitud tardó demasiado y fue cancelada.'
						: 'No fue posible conectar con el servidor. Verifique su conexión e intente nuevamente.';

				if (!isHandledResponse) {
					response.type = type;
					response.message = message;
					console.error('Error de red al realizar la solicitud', { method, url, error });
				}

				Swal.fire({
					icon: type,
					title: '',
					html: message || 'No fue posible completar la solicitud.'
				});
				return response;
			}
		},
		openLoader() {
			this.load = this.$loading.show({
				color: "white"
			});
		},
		closeLoader() {
			this.load.hide();
		},
		formatDateTime(date) {
			return moment(date).format('LLL');
		},
		formatDate(date) {
			return moment(date).format('LL');
		},
		formatNumber(numero, moneda, sinRedondeo = false, esEntero = false) {
			let numeroFormateado;

			if (!sinRedondeo) {

				if (!esEntero) {
					numeroFormateado = numeral(numero).format('0,0.00');
				} else {
					numeroFormateado = numeral(numero).format('0,0');
				}
			}

			if (typeof moneda == 'object' && Object.keys(moneda).length) {
				numeroFormateado = `${(moneda.divisa ? moneda.divisa : 'MXN')} ${numeroFormateado}`;
			}

			return numeroFormateado;
		}
	}
});
